import { Component } from '@angular/core';

import {AlertController, App, NavController} from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {DocumentSelectForm} from "../../utils/document-select/document-select";
import { DocumentViewer } from '../../utils/document-viewer/document-viewer';
import {HomePage} from "../../home/home";
import {RibSelect} from "../../utils/rib-select/rib-select";

@Component({
    selector: 'page-documents',
    templateUrl: 'documents.html'
})
export class DocumentsPage {
    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;
    formations: Observable<any[]>;
    experiences: Observable<any[]>;
    certificates: Observable<any[]>;
    languages: Observable<any[]>;
    identity_documents: any;
    video_documents: any;


    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public app: App
    ) {
        //userData.setToken('nova2');
    }
    back(event)
    {
        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
    ngAfterViewInit() {

        var that = this;
        this.userData.load().subscribe(data => {
            that.loadDocuments()
        });



        /*this.userData.getToken().then(function(token){

            that.formationsRef = that.afDatabase.list('/users/'+token+'/formations');
            that.experiencesRef = that.afDatabase.list('/users/'+token+'/experiences');
            that.certificatesRef = that.afDatabase.list('/users/'+token+'/certificates');
            that.languagesRef = that.afDatabase.list('/users/'+token+'/languages');

            that.formations = that.formationsRef.valueChanges();
            that.experiences = that.experiencesRef.valueChanges();
            that.certificates = that.certificatesRef .valueChanges();
            that.languages = that.languagesRef.valueChanges();
        });*/
    }
    loadDocuments()
    {
        var that = this;
        that.identity_documents = this.userData.get('documents');
        if(!that.identity_documents)that.identity_documents={};
        that.video_documents = [];

        var videos = this.userData.get('videos');
        if(videos)
        {
            that.video_documents = videos;
        }
    }
    chooseDocument(mode)
    {
        var multiple = false;
        var hideCamera = false;
        var fileExtensions:any = false;
        var allowFileTypes:any = false;

        if(mode == "identity" || mode == "vitale"){
            multiple = true;
        }
        if(mode == "cv"){
            hideCamera = true;
            fileExtensions = ".doc, .docx, .pdf, .odt";
            allowFileTypes = "application/pdf , application/msword , application/vnd.openxmlformats-officedocument.wordprocessingml.document , application/vnd.oasis.opendocument.text";
        }
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, {
            document_type: mode,
            multiple: multiple,
            hideCamera:hideCamera,
            fileExtensions:fileExtensions,
            allowFileTypes:allowFileTypes
        });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {
                this.userData.update('documents/'+data.document_type,'modified',true);
                this.loadDocuments();
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    openDocument(document)
    {
        let documentSelectModal = this.modalCtrl.create(DocumentViewer, { document: document });
        documentSelectModal.onDidDismiss(data => {

        });
        documentSelectModal.present();
    }
    addRibInfo()
    {
        var that = this;
        let documentSelectModal = this.modalCtrl.create(RibSelect, { 'rib':that.identity_documents.rib_info });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.success){
                //console.log(data);
                that.userData.set('documents/rib_info',{'iban':data.iban});
                that.identity_documents.rib_info = {'iban':data.iban};
            }
        });
        documentSelectModal.present();
    }
    changeRibInfo()
    {
       this.addRibInfo();
    }
    /***
     * Toast management
     * @param {string} message
     */

    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    toastCancel(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    swipe(event)
    {
        /*if(event.direction === 2) {
            this.nav.parent.select(2);
        }*/
        if(event.direction === 4) {
            this.nav.parent.select(2);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/documents/documents.ts